import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Tab } from 'react-bootstrap'

//components
import withLocalization from '~/hoc/withLocalization';
import PayrollIntegrations from './PayrollIntegrations';
import ApiGatewayIntegration from './ApiGatewayIntegration';
import IntegrationSettings from './IntegrationSettings';

class Integrations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subTab: 'payroll_integrations',
        }
        this.handleSubTabChange = this.handleSubTabChange.bind(this);
    }

    handleSubTabChange = (tabName) => {
        this.setState({ subTab: tabName })
    }

    render() {
        const { subTab } = this.state;
        const { t } = this.props;
        return (
            <Tab.Container activeKey={subTab} id="BasicTabContainer" onSelect={(key) => { }} >
                <div className="custom-card">
                    <Row>
                        <Col sm={3}>
                            <ul className="list-group">
                                <li className={subTab === 'payroll_integrations' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                    onClick={() => this.handleSubTabChange('payroll_integrations')}>{t('Payroll Integration')}</li>
                                <li className={subTab === 'payroll_integrations_settings' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                    onClick={()=> this.handleSubTabChange('payroll_integrations_settings')}>{t('Payroll Integration')} {t('Settings')}</li>
                                <li className={subTab === 'api_gateway_integration' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                    onClick={() => this.handleSubTabChange('api_gateway_integration')}>{t('API Gateway Integration')}</li>
                            </ul>
                        </Col>
                        <Col sm={9}>
                            <Tab.Content>
                                <Tab.Pane eventKey="payroll_integrations">
                                    <PayrollIntegrations handleSubTabChange={this.handleSubTabChange} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="payroll_integrations_settings" mountOnEnter unmountOnExit>
                                    <IntegrationSettings onSaveSuccess={this.props.onSaveSuccess}/>
                                </Tab.Pane>
                                <Tab.Pane eventKey="api_gateway_integration">
                                    <ApiGatewayIntegration />
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </div>
            </Tab.Container>
        );
    }
}
export default inject('commonStore')(withLocalization(observer(Integrations)));
